import { useEffect, useState } from 'react';
import { useAuth } from '../../auth';
import { accessUiState, type AccessUi } from '../logic/accessWindow';

/**
 * Where the signed in guest stands against their access window, right now.
 * Recomputed every few minutes so a page left open across midnight, or a phone
 * that was offline when the window opened, says the right thing. Null when
 * nobody is signed in.
 */
export function useAccess(): AccessUi | null {
  const { session } = useAuth();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 5 * 60_000);
    return () => clearInterval(id);
  }, []);

  if (!session) return null;
  return accessUiState({
    now,
    arrivesOn: session.stay.arrives_on,
    departsOn: session.stay.departs_on,
    cancelled: session.stay.status === 'cancelled',
    serverWindow: session.window,
  });
}
